import { NOTIFICATIONS } from './notifications.constants';

const FLYER_TOAST_TIMEOUT = 10000;

export const NOTIFICATION_TOAST_CONFIGURATION = {
  autoClose: NOTIFICATIONS.NOTIFICATIONS_TIME_OUT,
  closeOnClick: true,
  className: 'toast-full',
  bodyClassName: 'toast-body'
};

export const FLYER_TOAST_CONFIGURATION = {
  autoClose: FLYER_TOAST_TIMEOUT,
  closeOnClick: false,
  className: 'flyer-toast-full',
  bodyClassName: 'flyer-toast-body'
};
